import {Component} from 'react';
import {change, reduxForm} from 'redux-form';
import {connect} from "react-redux";
import {compose} from "recompose";
import {getTimeZoneOffsetDefault} from '../shared/dateTimeLists';

class TimeZoneDefault extends Component {
    componentDidMount() {
        const offsetDefault = getTimeZoneOffsetDefault();
        this.props.dispatch(change('timeZoneForm', 'timeZoneDefault', offsetDefault));
    }

    render() {
        return null;
    }
}

const enhance = compose(
    connect(),
    reduxForm({
        form: 'timeZoneForm',
        initialValues: {
            timeZoneDefault: '0'
        }
    })
);

export default enhance(TimeZoneDefault);



// WEBPACK FOOTER //
// ./src/Fuse/components/TimeZoneDefault.js